import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useGradeQuizMutation } from "../../slices/fun_stuff/quizUsersSlice";
import { useLoadQuizChallenges } from '../../hooks/useLoadQuizChallenges';
import { useLoadQuizList } from '../../hooks/useLoadQuizList';
import { useLoadQuizScoreboard } from '../../hooks/useLoadQuizScoreboard';
import { useLoadQuizGroups } from '../../hooks/useLoadQuizGroups';
import { useSocket } from "../../context/SocketContext";
import { setQuizLiveGame } from "../../slices/fun_stuff/quizAuthSlice";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import RateQuiz from "./RateQuiz";
import Loader from "../Loader";
import EndQuizModal from "./EndQuizModal";

const GradeQuizBtn = ({ currentQuiz, correctAnswers, givenAnswers, quizStarted, setQuizStarted, setShowAnswers, setShowX, setShowCheck, challenged, timeExpired, setStartTimer, graded, resetQuiz, showSubmit, liveQuiz }) => {

    const { quizUserInfo, quizLiveGame } = useSelector((state) => state.quizAuth);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const socket = useSocket();

    const [quizCompleted, setQuizCompleted] = useState(false);
    const [numCorrect, setNumCorrect] = useState(0);
    const [showRateQuiz, setShowRateQuiz] = useState(false);
    const [showEndQuiz, setShowEndQuiz] = useState(false);

    const [gradeQuiz, { isLoading }] = useGradeQuizMutation();
    
    const { loadGroups } = useLoadQuizGroups();
    const { loadScoreboard } = useLoadQuizScoreboard();
    const { loadChallenges } = useLoadQuizChallenges();
    const { loadQuizzes } = useLoadQuizList();

    useEffect(() => {
        if (timeExpired) {
            window.alert('Time expired, time to be judged... I mean graded.');
            completedQuiz();
        }
    }, [timeExpired]);

    async function completedQuiz() {
        scrollToTop();
        setShowAnswers(true);
        setQuizStarted(false);
        setShowEndQuiz(true);

        let numberCorrect;
        if (graded || liveQuiz) {
            numberCorrect = await checkQuiz();
            setStartTimer(false);
        }

        try {
            await gradeQuiz({
                user_id: quizUserInfo.id,
                quiz_id: currentQuiz.id,
                answers: correctAnswers,
                givenAnswers,
                challenged,
                graded,
            }).unwrap();
            setQuizCompleted(true);
            if (!liveQuiz) {
                await Promise.all([
                    loadGroups(),
                    loadChallenges(),
                    loadScoreboard(),
                    loadQuizzes(),
                ]);
                toast.success("Quiz added to completed quizzes");
            } else {
                dispatch(setQuizLiveGame({ ...quizLiveGame,
                    totalCorrect: quizLiveGame.totalCorrect + numberCorrect,
                    totalQuestions: quizLiveGame.totalQuestions + Object.keys(correctAnswers).length,
                    numCorrect: numberCorrect,
                    numQuestions: Object.keys(correctAnswers).length,
                }));
                socket.emit('game_player_completed', { groupId: quizLiveGame.groupId, numCorrect: numberCorrect });
                await loadScoreboard();
            }
        } catch (error) {
            toast.error(error?.data?.message || error.error);
        }
    }
    
    function scrollToTop() {
        const titleElement = document.getElementById('title');
        if (titleElement) {
        titleElement.scrollIntoView({ behavior: 'smooth' });
        }
    }

    async function checkQuiz() {
        const newShowCheck = {};
        const newShowX = {};
        let numberCorrect = 0;

        for (let i = 0; i < Object.keys(correctAnswers).length; i++) {
            if (correctAnswers[i]) {
                newShowCheck[i] = true;
                newShowX[i] = false;
                numberCorrect++;
            } else {
                newShowCheck[i] = false;
                newShowX[i] = true;
            }
        }

        setNumCorrect(numberCorrect);
        setShowCheck(newShowCheck);
        setShowX(newShowX);

        return numberCorrect;
    }

    async function handleReset(e) {
        e.preventDefault();
        if (liveQuiz) {
            navigate('/quizgame/quizprofile', {
            state: {
                quizCompleted: true,
            }   
            });
            return;
        }

        setShowRateQuiz(true);
        if (!quizCompleted) {
            await completedQuiz();
        }
    }

    if (isLoading) return <Loader />
    return (
        <div>
            {(quizUserInfo && showSubmit) ? (
            <Button className="quiz-btn" onClick={() => completedQuiz()} disabled={isLoading}>
                {liveQuiz ? "Finished!" : graded ? "Grade Quiz" : "Show Answers"}
            </Button>
            ) : (
            showSubmit && <Button 
                id="show-answer-btn" 
                className="quiz-btn" 
                onClick={() => {
                    scrollToTop();
                    setShowAnswers(true);
                    setQuizStarted(false);
                    setShowEndQuiz(true);
                }}
            >
                Show Answers
            </Button>
            )}

            {(!liveQuiz || !quizStarted) &&
            <Button onClick={(e) => handleReset(e)} className="quiz-btn">
                <FontAwesomeIcon icon={faRotateLeft} className='me-2'/>
                {liveQuiz ? "Return to game room" : "Reset Quiz"}
            </Button>}

            {showEndQuiz && 
            <EndQuizModal 
                numCorrect={numCorrect} 
                numQuestions={Object.keys(correctAnswers).length}
                graded={graded}
                setShowEndQuiz={setShowEndQuiz}
                resetQuiz={handleReset}
                liveQuiz={liveQuiz}
            />}

            {showRateQuiz && 
            <RateQuiz 
                setShowRateQuiz={setShowRateQuiz} 
                quizId={currentQuiz.id} 
                resetQuiz={resetQuiz}
            />}
        </div>
    );
}

export default GradeQuizBtn;